
import * as React from 'react';
import EditorProps from '../../components/editorinterface';
import { FormControl } from 'react-bootstrap';
import './index.css';
import { re_weburl } from './regex-weburl';
// https://gist.github.com/dperini/729294
// Changed var to const, added export

interface Props extends EditorProps {

};

class URLEditor extends React.Component<Props, URLEditorState> {

	value: null | string;
  clickableLink: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);
    this.value = props.value;
    this.onInputChange = this.onInputChange.bind(this);
    this.editorSelected = this.editorSelected.bind(this);
    this.editorBlurred = this.editorBlurred.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {editMode: false};
    this.clickableLink = React.createRef();
  }

  public render() {
    const props = this.props;
    const state = this.state;
	var buttonText = props.field.buttonText ? props.field.buttonText : props.value;
	var isButton = props.field.buttonText ? true : false;

    //jndp code review: Il faudrait ouvrir l'url dans une fenêtre (ou tab)
	return (
	  (state.editMode || this.value === null || this.value === '') ?
	  <FormControl
		type="url"
		value={this.value === null || this.value ===undefined ? "" : this.value}
		placeholder="Enter URL"
		onChange={this.onInputChange}
		onBlur={this.editorBlurred}
		readOnly={!!props.field.readOnly}
		onKeyDown={this.onKeyDown}
		// Autofocus only when clicked, needed to not get focus on loaded page when empty
		autoFocus={!(this.value === null || this.value === '')}
	  />
	  :
	  <div ref={this.clickableLink} className="form-control url-link-container" onClick={this.editorSelected}>
		<a  href={props.value} onClick={this.editorBlurred}>{buttonText}</a>
	  </div>
	);		
  }

  public componentDidMount() {
    this.updateOverflowEllipis();
  }

  public componentDidUpdate() {
    this.updateOverflowEllipis();
  }

  private updateOverflowEllipis() {
    if(!this.clickableLink.current) {
      return;
    }
    const node = this.clickableLink.current;
    if(node.scrollWidth > node.clientWidth) {
      node.style.overflow = 'hidden';
      node.style.textOverflow = 'ellipsis';
      node.style.whiteSpace = 'nowrap';
      node.style.width = node.offsetWidth+"px";
    }else {
      node.style.removeProperty('overflow');
      node.style.removeProperty('textOverflow');
      node.style.removeProperty('whiteSpace');
      node.style.removeProperty('width');
    }
  }

  private onInputChange(e: any) {
    this.value = e.target.value;
		if (this.value === null)
			this.value = '';
    this.setState({editMode:true});
    if (this.value === '' || re_weburl.test(this.value))
      this.props.onChange(this.props.field.id, this.value);
  }

  private editorSelected() {
		if (!this.state.editMode && !this.props.field.readOnly)
			this.setState({editMode:true});
  }

  private editorBlurred() {
		if (this.state.editMode)
    	this.setState({editMode:false});
  }

  private onKeyDown(e: any) {
    if (e.keyCode == 13 || e.keyCode == 27 || e.keyCode == 9) // enter, escape or tab
        this.editorBlurred();
  }
}

type URLEditorState = {
    editMode: boolean;
}

export default URLEditor;



// WEBPACK FOOTER //
// ./src/components/urleditor/index.tsx